// import {
//   useCallback,
//   useEffect,
//   useLayoutEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import {
//   Box,
//   Paper,
//   Typography,
//   IconButton,
//   TextField,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import {
//   ArrowBackRounded,
//   AttachFileRounded,
//   SendRounded,
//   KeyboardArrowDownRounded,
// } from "@mui/icons-material";
// import { keyframes } from "@mui/system";

// import MessageCard from "./components/MessageCard";
// import { messagesService } from "./services/messagesService";
// import {
//   textSecondary,
//   POLLING_INTERVAL_MS,
//   accentColor,
// } from "../../constants/consts";
// import { playIfBackground } from "../../utils/playNotificationSound";

// /* ─────────────── Animasyonlar ─────────────── */
// const fadeIn = keyframes`
//   from { opacity: 0; }
//   to   { opacity: 1; }
// `;
// const fadeInUp = keyframes`
//   from { opacity: 0; transform: translateY(20px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;
// const slideDown = keyframes`
//   from { opacity: 0; transform: translateY(-16px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;
// const slideUp = keyframes`
//   from { opacity: 0; transform: translateY(16px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;
// const sendPulse = keyframes`
//   0%   { box-shadow: 0 0 0 0 ${accentColor}66; }
//   100% { box-shadow: 0 0 0 12px ${accentColor}00; }
// `;

// /* ─────────────── Sabitler ─────────────── */
// const NEAR_BOTTOM_PX = 200;

// export default function SupportMessages({ user }) {
//   const navigate = useNavigate();
//   const { supportId } = useParams();
//   const location = useLocation();
//   const initial = location.state || {};

//   const userId = user?.user_id;
//   const username = user?.username;

//   /* ─── Panel tipi ─── */
//   const rawUserType = String(user?.user_type || "").toLowerCase();
//   const isSupporter = rawUserType === "destek";
//   const messageUserType = isSupporter ? "nortek" : "user";

//   /* ─── sunucuKodu state (destekçide fallback ile doldurulur) ─── */
//   const [sunucuKodu, setSunucuKodu] = useState(
//     isSupporter
//       ? initial.sunucuKodu || user?.sunucu_kodu || ""
//       : user?.sunucu_kodu || "",
//   );

//   const [messages, setMessages] = useState([]);
//   const [title] = useState(initial.title || "Destek");
//   const [status] = useState(initial.status || "");
//   const [text, setText] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [sending, setSending] = useState(false);
//   const [error, setError] = useState("");
//   const [showScrollDown, setShowScrollDown] = useState(false);

//   const prevCountRef = useRef(0);
//   const firstScrollDoneRef = useRef(false);
//   const pollRef = useRef(null);
//   const messagesRef = useRef(null);
//   const bottomRef = useRef(null);
//   const fileRef = useRef(null);

//   // const isCompleted = (status || "").toLowerCase().includes("tamam");

//   const statusLower = (status || "").toLowerCase();
//   const isCompleted = statusLower.includes("tamam");
//   const isCancelled =
//     statusLower.includes("cancel") || statusLower.includes("iptal");
//   const isReadOnly = isCompleted || isCancelled;

//   /* ─────────────── Normalize ─────────────── */
//   const normalized = useMemo(() => {
//     const mapped = messages.map((m) => {
//       const senderIdRaw = m.senderId ?? m.sender_id ?? m.senderid;
//       const senderNameRaw =
//         m.senderName ?? m.sender_name ?? m.owner_username ?? "Bilinmiyor";
//       const msgType = m.type ?? m.msgType ?? "txt";
//       const createdAt = m.created_at ?? m.createdAt ?? "";
//       return {
//         id: m.id,
//         senderId: senderIdRaw,
//         senderName: senderNameRaw,
//         receiverId: m.receiverId ?? m.receiver_id ?? null,
//         message: m.message ?? "",
//         createdAt,
//         msgType,
//       };
//     });
//     return mapped.slice().reverse();
//   }, [messages]);

//   /* ─────────────── Load messages ─────────────── */
//   const loadMessages = useCallback(
//     async (silent = false) => {
//       if (!silent) setLoading(true);
//       try {
//         const data = await messagesService.getMessages(supportId);
//         setMessages(Array.isArray(data) ? data : []);

//         await messagesService.changeUpdateValue({
//           target: isSupporter ? "nortek" : "user",
//           newValue: false,
//           userId,
//           root: "msg",
//         });
//         await messagesService.updateUnread({
//           unread: 0,
//           supportId,
//           type: isSupporter ? "nortek" : "user",
//         });
//       } catch (err) {
//         console.error(err);
//         if (!silent) setError("Mesajlar yüklenemedi");
//       } finally {
//         if (!silent) setLoading(false);
//       }
//     },
//     [supportId, userId, isSupporter],
//   );

//   useEffect(() => {
//     loadMessages();
//   }, [loadMessages]);

//   /* ─────────────── Sunucu kodu fallback (destekçi için) ─────────────── */
//   useEffect(() => {
//     if (!isSupporter) return;
//     if (sunucuKodu) return;
//     if (!normalized.length) return;
//     if (!userId) return;

//     const otherMsg = normalized.find(
//       (m) => String(m.senderId) !== String(userId),
//     );
//     const customerId = otherMsg?.senderId || otherMsg?.receiverId;
//     if (!customerId) return;

//     let cancelled = false;
//     (async () => {
//       try {
//         const u = await messagesService.getUserById(customerId);
//         if (cancelled) return;
//         const kodu = u?.sunucu_kodu || "";
//         if (kodu) setSunucuKodu(kodu);
//       } catch (err) {
//         console.warn("Sunucu kodu alınamadı:", err);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [isSupporter, sunucuKodu, normalized, userId]);

//   /* ─────────────── Polling ─────────────── */
//   useEffect(() => {
//     if (!userId) return;

//     const tick = async () => {
//       try {
//         const changed = await messagesService.checkDataIsUpdated({
//           target: isSupporter ? "nortek" : "user",
//           userId,
//           root: "msg",
//         });
//         if (changed) {
//           playIfBackground("message");
//           await loadMessages(true);
//         }
//       } catch (err) {
//         console.warn("Polling error:", err?.message);
//       }
//     };
//     pollRef.current = setInterval(tick, POLLING_INTERVAL_MS);
//     return () => pollRef.current && clearInterval(pollRef.current);
//   }, [userId, loadMessages, isSupporter]);

//   /* ─────────────── Auto-scroll (WhatsApp davranışı) ─────────────── */
//   // Ana mekanizma: bottomRef.scrollIntoView() — scrollHeight'tan daha güvenilir
//   useLayoutEffect(() => {
//     if (loading) return;
//     if (normalized.length === 0) return;
//     const bottom = bottomRef.current;
//     const el = messagesRef.current;
//     if (!bottom || !el) return;

//     const isFirstLoad = !firstScrollDoneRef.current;
//     const hasNewMessage = normalized.length > prevCountRef.current;

//     if (isFirstLoad) {
//       // İlk açılış: anında en alta (animasyonsuz)
//       bottom.scrollIntoView({ block: "end" });
//       requestAnimationFrame(() => {
//         bottom.scrollIntoView({ block: "end" });
//       });
//       firstScrollDoneRef.current = true;
//     } else if (hasNewMessage) {
//       // Yeni mesaj geldi: kullanıcı dipteyse otomatik smooth scroll
//       const nearBottom =
//         el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
//       if (nearBottom) {
//         // İki frame bekle — yeni mesaj DOM'a işlensin
//         requestAnimationFrame(() => {
//           requestAnimationFrame(() => {
//             bottom.scrollIntoView({
//               behavior: "smooth",
//               block: "end",
//             });
//           });
//         });
//       }
//     }

//     prevCountRef.current = normalized.length;
//   }, [normalized.length, loading]);

//   /* ─────────────── Resim/audio geç yüklenince dipteyse yapıştır ─────────────── */
//   useEffect(() => {
//     const el = messagesRef.current;
//     if (!el) return;

//     const onMediaLoad = () => {
//       if (!firstScrollDoneRef.current) return;
//       const nearBottom =
//         el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
//       if (nearBottom && bottomRef.current) {
//         bottomRef.current.scrollIntoView({ block: "end" });
//       }
//     };

//     el.addEventListener("load", onMediaLoad, true);
//     el.addEventListener("loadedmetadata", onMediaLoad, true);
//     return () => {
//       el.removeEventListener("load", onMediaLoad, true);
//       el.removeEventListener("loadedmetadata", onMediaLoad, true);
//     };
//   }, []);

//   /* ─────────────── "Aşağı kaydır" göstergesi ─────────────── */
//   useEffect(() => {
//     const el = messagesRef.current;
//     if (!el) return;

//     const onScroll = () => {
//       const nearBottom =
//         el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
//       setShowScrollDown(!nearBottom && normalized.length > 0);
//     };

//     el.addEventListener("scroll", onScroll);
//     // İlk render'da da bir kez çalıştır
//     onScroll();
//     return () => el.removeEventListener("scroll", onScroll);
//   }, [normalized.length]);

//   /* ─────────────── Karşı taraf ID ─────────────── */
//   const receiverId = useMemo(() => {
//     if (!normalized.length) return null;
//     const last = normalized[normalized.length - 1];
//     return String(last.senderId) === String(userId)
//       ? last.receiverId
//       : last.senderId;
//   }, [normalized, userId]);

//   /* ─────────────── Gönderim sonrası ─────────────── */
//   const afterSend = async () => {
//     await loadMessages(true);
//     try {
//       await messagesService.changeUpdateValue({
//         target: isSupporter ? "user" : "nortek",
//         newValue: true,
//         userId: receiverId,
//         root: "msg",
//       });

//       await messagesService.updateUnread({
//         unread: 1,
//         supportId,
//         type: isSupporter ? "user" : "nortek",
//       });
//     } catch (e) {
//       console.warn(e);
//     }
//   };

//   /* ─────────────── Gönder ─────────────── */
//   const handleSend = async () => {
//     const trimmed = text.trim();
//     if (!trimmed || sending || isCompleted) return;
//     setSending(true);
//     setError("");
//     try {
//       await messagesService.addMessage({
//         supportId,
//         senderId: userId,
//         receiverId,
//         message: trimmed,
//         senderName: username,
//         userType: messageUserType,
//         type: "txt",
//       });
//       setText("");
//       await afterSend();
//     } catch (err) {
//       console.error(err);
//       setError("Mesaj gönderilemedi");
//     } finally {
//       setSending(false);
//     }
//   };

//   /* ─────────────── Dosya ─────────────── */
//   const handleFileChange = async (e) => {
//     const file = e.target.files?.[0];
//     e.target.value = "";
//     if (!file || sending || isCompleted) return;

//     const ext = file.name.split(".").pop()?.toLowerCase() || "";
//     setSending(true);
//     setError("");

//     try {
//       let kodu = sunucuKodu;

//       if (!kodu && isSupporter) {
//         const otherMsg = normalized.find(
//           (m) => String(m.senderId) !== String(userId),
//         );
//         const customerId = otherMsg?.senderId || otherMsg?.receiverId;

//         if (customerId) {
//           try {
//             const u = await messagesService.getUserById(customerId);
//             kodu = u?.sunucu_kodu || "";
//             if (kodu) setSunucuKodu(kodu);
//           } catch (err) {
//             console.warn("Sunucu kodu çekilemedi:", err);
//           }
//         }
//       }

//       const res = await messagesService.uploadFile(file, kodu, ext);
//       const url = res?.url;
//       if (!url) throw new Error("Yükleme başarısız");

//       await messagesService.addMessage({
//         supportId,
//         senderId: userId,
//         receiverId,
//         message: url,
//         senderName: username,
//         userType: messageUserType,
//         type: ext,
//       });
//       await afterSend();
//     } catch (err) {
//       console.error("[Upload error]", err?.response?.data || err);
//       setError(err?.message || "Dosya yüklenemedi");
//     } finally {
//       setSending(false);
//     }
//   };

//   /* ─────────────── Aşağı kaydır ─────────────── */
//   const scrollToBottom = () => {
//     bottomRef.current?.scrollIntoView({
//       behavior: "smooth",
//       block: "end",
//     });
//   };

//   /* ─────────────── Render ─────────────── */
//   return (
//     <Box
//       sx={{
//         height: "100dvh",
//         width: "100%",
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//         boxSizing: "border-box",
//         position: "relative",
//         backgroundColor: "#ECE5DD",
//       }}
//     >
//       {/* WhatsApp benzeri hafif arka plan dokusu */}
//       <Box
//         sx={{
//           position: "absolute",
//           inset: 0,
//           pointerEvents: "none",
//           opacity: 0.35,
//           backgroundImage:
//             "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.6) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.5) 0%, transparent 40%)",
//         }}
//       />

//       <Paper
//         elevation={0}
//         sx={{
//           position: "relative",
//           zIndex: 1,
//           width: "100%",
//           height: "100%",
//           borderRadius: 0,
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//           bgcolor: "transparent",
//           animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both`,
//         }}
//       >
//         {/* ─────────── HEADER ─────────── */}
//         <Box
//           sx={{
//             px: { xs: 1.5, sm: 2 },
//             py: 1.25,
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//             flexShrink: 0,
//             background: "linear-gradient(135deg, #045781 0%, #0d6a9e 100%)",
//             color: "#fff",
//             boxShadow: "0 2px 12px rgba(4,87,129,0.25)",
//             zIndex: 2,
//             animation: `${slideDown} 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
//           }}
//         >
//           <IconButton
//             onClick={() => navigate(-1)}
//             size="small"
//             sx={{
//               color: "#fff",
//               transition: "transform 0.2s ease",
//               "&:hover": {
//                 transform: "translateX(-3px)",
//                 backgroundColor: "rgba(255,255,255,0.12)",
//               },
//             }}
//           >
//             <ArrowBackRounded />
//           </IconButton>
//           <Typography
//             sx={{
//               fontWeight: 700,
//               flex: 1,
//               minWidth: 0,
//               color: "#fff",
//               fontSize: 15.5,
//             }}
//             noWrap
//           >
//             {title}
//           </Typography>
//           {/* {isCompleted && (
//             <Typography
//               variant="caption"
//               sx={{
//                 color: "#fff",
//                 fontWeight: 700,
//                 bgcolor: "rgba(255,255,255,0.20)",
//                 border: "1px solid rgba(255,255,255,0.28)",
//                 px: 1,
//                 py: 0.25,
//                 borderRadius: 10,
//                 animation: `${fadeIn} 0.4s ease-out 0.3s backwards`,
//               }}
//             >
//               Tamamlandı
//             </Typography>
//           )} */}
//           {isReadOnly && (
//             <Typography
//               variant="caption"
//               sx={{
//                 color: "#fff",
//                 fontWeight: 700,
//                 bgcolor: isCancelled
//                   ? "rgba(185,28,28,0.55)"
//                   : "rgba(255,255,255,0.20)",
//                 border: isCancelled
//                   ? "1px solid rgba(254,202,202,0.5)"
//                   : "1px solid rgba(255,255,255,0.28)",
//                 px: 1,
//                 py: 0.25,
//                 borderRadius: 10,
//                 animation: `${fadeIn} 0.4s ease-out 0.3s backwards`,
//               }}
//             >
//               {isCancelled ? "İptal Edildi" : "Tamamlandı"}
//             </Typography>
//           )}
//         </Box>

//         {/* ─────────── MESSAGES ─────────── */}
//         <Box
//           ref={messagesRef}
//           sx={{
//             flex: 1,
//             minHeight: 0,
//             overflowY: "auto",
//             overflowX: "hidden",
//             overscrollBehavior: "contain",
//             p: { xs: 1.5, sm: 2 },
//             position: "relative",
//             backgroundColor: "rgba(236,229,221,0.6)",
//             "&::-webkit-scrollbar": { width: 8 },
//             "&::-webkit-scrollbar-thumb": {
//               bgcolor: "rgba(15,50,65,0.15)",
//               borderRadius: 4,
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               bgcolor: "rgba(15,50,65,0.28)",
//             },
//           }}
//         >
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 6,
//                 gap: 1.5,
//               }}
//             >
//               <CircularProgress size={32} />
//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: textSecondary,
//                   fontWeight: 600,
//                   animation: `${fadeIn} 1s ease-out both`,
//                 }}
//               >
//                 Mesajlar yükleniyor…
//               </Typography>
//             </Box>
//           ) : normalized.length === 0 ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 8,
//                 gap: 1.5,
//                 animation: `${fadeInUp} 0.5s ease-out 0.2s backwards`,
//               }}
//             >
//               <Box
//                 sx={{
//                   width: 64,
//                   height: 64,
//                   borderRadius: "50%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   bgcolor: `${accentColor}14`,
//                   color: accentColor,
//                   animation: "emptyPulse 2.4s ease-in-out infinite",
//                   "@keyframes emptyPulse": {
//                     "0%, 100%": { transform: "scale(1)" },
//                     "50%": { transform: "scale(1.06)" },
//                   },
//                 }}
//               >
//                 <SendRounded sx={{ fontSize: 28 }} />
//               </Box>
//               <Typography
//                 sx={{
//                   textAlign: "center",
//                   color: textSecondary,
//                   fontWeight: 600,
//                   fontSize: 13.5,
//                 }}
//               >
//                 Henüz mesaj yok. İlk mesajı siz gönderin.
//               </Typography>
//             </Box>
//           ) : (
//             <>
//               {/* {normalized.map((m, i) => {
//                 const isMine = String(m.senderId) === String(userId);
//                 const isNew = i >= prevCountRef.current;
//                 return (
//                   <MessageCard
//                     key={m.id}
//                     msg={m.message}
//                     name={m.senderName}
//                     time={formatTime(m.createdAt)}
//                     isMine={isMine}
//                     msgType={m.msgType}
//                     animate={isNew}
//                     index={i}
//                   />
//                 );
//               })} */}
//               {normalized.map((m, i) => {
//                 const isMine = String(m.senderId) === String(userId);
//                 const isNew = i >= prevCountRef.current;
//                 const prev = i > 0 ? normalized[i - 1] : null;
//                 const showDaySeparator =
//                   !prev || isDifferentDay(prev.createdAt, m.createdAt);

//                 return (
//                   <Box key={m.id}>
//                     {showDaySeparator && (
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "center",
//                           my: 1.5,
//                           animation: `${fadeIn} 0.4s ease-out both`,
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             px: 1.5,
//                             py: 0.4,
//                             borderRadius: 10,
//                             backgroundColor: "rgba(255,255,255,0.85)",
//                             border: "1px solid rgba(15,50,65,0.08)",
//                             boxShadow: "0 1px 3px rgba(15,50,65,0.06)",
//                             fontSize: 11,
//                             fontWeight: 700,
//                             color: "#546e7a",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.04em",
//                           }}
//                         >
//                           {formatDayLabel(m.createdAt)}
//                         </Box>
//                       </Box>
//                     )}

//                     <MessageCard
//                       msg={m.message}
//                       name={m.senderName}
//                       time={formatTime(m.createdAt)}
//                       isMine={isMine}
//                       msgType={m.msgType}
//                       animate={isNew}
//                       index={i}
//                     />
//                   </Box>
//                 );
//               })}
//               {/* Bottom anchor — scrollIntoView hedefi */}
//               <div ref={bottomRef} style={{ height: 1 }} />
//             </>
//           )}

//           {/* Aşağı kaydır butonu */}
//           {showScrollDown && (
//             <Box
//               onClick={scrollToBottom}
//               sx={{
//                 position: "sticky",
//                 bottom: 8,
//                 ml: "auto",
//                 mr: 0.5,
//                 width: 40,
//                 height: 40,
//                 borderRadius: "50%",
//                 backgroundColor: "rgba(255,255,255,0.98)",
//                 border: "1px solid rgba(15,50,65,0.12)",
//                 boxShadow: "0 4px 14px rgba(15,50,65,0.18)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 cursor: "pointer",
//                 zIndex: 5,
//                 animation: "floatIn 0.3s cubic-bezier(0.22, 1, 0.36, 1) both",
//                 "@keyframes floatIn": {
//                   from: { opacity: 0, transform: "translateY(8px)" },
//                   to: { opacity: 1, transform: "translateY(0)" },
//                 },
//                 "&:hover": {
//                   backgroundColor: "#fff",
//                   transform: "scale(1.06)",
//                 },
//                 "&:active": { transform: "scale(0.94)" },
//               }}
//             >
//               <KeyboardArrowDownRounded sx={{ color: "#334155" }} />
//             </Box>
//           )}
//         </Box>

//         {error && (
//           <Alert
//             severity="error"
//             sx={{
//               mx: 1.5,
//               my: 0.5,
//               animation: `${slideUp} 0.3s ease-out both`,
//             }}
//             onClose={() => setError("")}
//           >
//             {error}
//           </Alert>
//         )}

//         {/* ─────────── INPUT ─────────── */}
//         <Box
//           sx={{
//             px: { xs: 1.5, sm: 2 },
//             py: 1.25,
//             display: "flex",
//             gap: 1,
//             alignItems: "flex-end",
//             borderTop: "1px solid rgba(15,50,65,0.08)",
//             backgroundColor: "#fff",
//             boxShadow: "0 -2px 12px rgba(15,50,65,0.06)",
//             flexShrink: 0,
//             zIndex: 2,
//             animation: `${slideUp} 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.15s backwards`,
//           }}
//         >
//           <input
//             ref={fileRef}
//             type="file"
//             hidden
//             accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.xml"
//             onChange={handleFileChange}
//           />
//           <IconButton
//             onClick={() => fileRef.current?.click()}
//             disabled={isCompleted || sending}
//             title="Dosya ekle"
//             sx={{
//               transition: "transform 0.2s ease, color 0.2s ease",
//               "&:hover": {
//                 transform: "scale(1.1) rotate(-12deg)",
//                 color: accentColor,
//               },
//               "&:active": { transform: "scale(0.92) rotate(0deg)" },
//             }}
//           >
//             <AttachFileRounded />
//           </IconButton>

//           <TextField
//             fullWidth
//             multiline
//             maxRows={6}
//             size="small"
//             placeholder={isCompleted ? "Bu talep tamamlandı" : "Mesaj..."}
//             value={text}
//             onChange={(e) => setText(e.target.value)}
//             disabled={isCompleted}
//             onKeyDown={(e) => {
//               if (e.key === "Enter" && !e.shiftKey) {
//                 e.preventDefault();
//                 handleSend();
//               }
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: 3,
//                 transition:
//                   "box-shadow 0.25s ease, background-color 0.25s ease",
//                 "&.Mui-focused": {
//                   boxShadow: `0 0 0 3px ${accentColor}22`,
//                 },
//               },
//             }}
//           />

//           <IconButton
//             onClick={handleSend}
//             disabled={isCompleted || sending || !text.trim()}
//             sx={{
//               bgcolor: accentColor,
//               color: "#fff",
//               transition:
//                 "transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
//               "&:hover": {
//                 bgcolor: accentColor,
//                 opacity: 0.95,
//                 transform: "scale(1.08) rotate(-8deg)",
//               },
//               "&:active": { transform: "scale(0.9)" },
//               "&.Mui-disabled": { bgcolor: "#ccc", color: "#fff" },
//               "&:not(:disabled)": {
//                 animation: `${sendPulse} 1.8s ease-out infinite`,
//               },
//             }}
//           >
//             {sending ? (
//               <CircularProgress size={20} sx={{ color: "#fff" }} />
//             ) : (
//               <SendRounded />
//             )}
//           </IconButton>
//         </Box>
//       </Paper>
//     </Box>
//   );
// }

// // function formatTime(value) {
// //   if (!value) return "";
// //   const d = new Date(value);
// //   if (isNaN(d.getTime())) return "";
// //   const hh = d.getHours().toString().padStart(2, "0");
// //   const mm = d.getMinutes().toString().padStart(2, "0");
// //   return `${hh}:${mm}`;
// // }
// /* ─────────────── Zaman formatlayıcı (akıllı) ─────────────── */

// // Sunucudan gelen tarihi güvenli şekilde Date objesine çevirir.
// // - ISO string ("2026-05-20T15:48:49.000Z") → doğrudan parse
// // - MySQL format ("2026-05-20 15:48:49") → UTC varsayıp düzelt
// function parseServerDate(value) {
//   if (!value) return null;

//   // Zaten Date objesi
//   if (value instanceof Date) return isNaN(value) ? null : value;

//   const str = String(value).trim();

//   // "2026-05-20 15:48:49" → "2026-05-20T15:48:49" (Safari/iOS için gerekli)
//   // Sonunda Z yoksa UTC kabul et ve Z ekle
//   let normalized = str.includes("T") ? str : str.replace(" ", "T");
//   const hasTz = /[Zz]|[+-]\d{2}:?\d{2}$/.test(normalized);
//   if (!hasTz) normalized += "Z"; // MySQL DATETIME'ı UTC kabul et

//   const d = new Date(normalized);
//   return isNaN(d.getTime()) ? null : d;
// }

// // Saat: "15:48"
// export function formatTime(value) {
//   const d = parseServerDate(value);
//   if (!d) return "";

//   const hh = d.getHours().toString().padStart(2, "0");
//   const mm = d.getMinutes().toString().padStart(2, "0");
//   return `${hh}:${mm}`;
// }

// // Gün etiketi: "Bugün", "Dün" veya "20 May 2026"
// export function formatDayLabel(value) {
//   const d = parseServerDate(value);
//   if (!d) return "";

//   const now = new Date();
//   const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//   const that = new Date(d.getFullYear(), d.getMonth(), d.getDate());

//   const diffDays = Math.round((today - that) / 86400000);

//   if (diffDays === 0) return "Bugün";
//   if (diffDays === 1) return "Dün";
//   if (diffDays < 7)
//     return [
//       "Pazar",
//       "Pazartesi",
//       "Salı",
//       "Çarşamba",
//       "Perşembe",
//       "Cuma",
//       "Cumartesi",
//     ][d.getDay()];

//   const months = [
//     "Oca",
//     "Şub",
//     "Mar",
//     "Nis",
//     "May",
//     "Haz",
//     "Tem",
//     "Ağu",
//     "Eyl",
//     "Eki",
//     "Kas",
//     "Ara",
//   ];
//   const year =
//     d.getFullYear() !== now.getFullYear() ? ` ${d.getFullYear()}` : "";
//   return `${d.getDate()} ${months[d.getMonth()]}${year}`;
// }

// // İki mesajın farklı güne ait olup olmadığını kontrol eder
// function isDifferentDay(a, b) {
//   const d1 = parseServerDate(a);
//   const d2 = parseServerDate(b);
//   if (!d1 || !d2) return false;
//   return (
//     d1.getFullYear() !== d2.getFullYear() ||
//     d1.getMonth() !== d2.getMonth() ||
//     d1.getDate() !== d2.getDate()
//   );
// }
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  TextField,
  CircularProgress,
  Alert,
} from "@mui/material";
import {
  ArrowBackRounded,
  AttachFileRounded,
  SendRounded,
  KeyboardArrowDownRounded,
} from "@mui/icons-material";
import { keyframes } from "@mui/system";

import MessageCard from "./components/MessageCard";
import { messagesService } from "./services/messagesService";
import {
  textSecondary,
  POLLING_INTERVAL_MS,
  accentColor,
} from "../../constants/consts";
import { playIfBackground } from "../../utils/playNotificationSound";

/* ─────────────── Animasyonlar ─────────────── */
const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-16px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const slideUp = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;
const sendPulse = keyframes`
  0%   { box-shadow: 0 0 0 0 ${accentColor}66; }
  100% { box-shadow: 0 0 0 12px ${accentColor}00; }
`;

/* ─────────────── Sabitler ─────────────── */
const NEAR_BOTTOM_PX = 200;

/* ─────────────── Zaman yardımcıları ─────────────── */

/**
 * Sunucudan gelen tarihi güvenli şekilde Date objesine çevirir.
 * Desteklenen formatlar:
 *  - RFC 1123 / HTTP Date: "Tue, 13 Oct 2026 11:38:34 GMT"   ← DIA API bunu gönderiyor
 *  - ISO 8601:             "2026-05-20T15:48:49.000Z"
 *  - ISO + TZ:             "2026-05-20T15:48:49+03:00"
 *  - MySQL DATETIME:       "2026-05-20 15:48:49"  (UTC kabul edilir)
 *  - MySQL DATE:           "2026-05-20"           (00:00 UTC)
 *  - Unix timestamp:       1758295729 (saniye) veya 1758295729000 (ms)
 *  - Date objesi:          doğrudan döner
 */
function parseServerDate(value) {
  if (value === null || value === undefined || value === "") return null;

  // Zaten Date objesi
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  // Sayısal timestamp
  if (typeof value === "number") {
    const ms = value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return isNaN(d.getTime()) ? null : d;
  }

  const str = String(value).trim();
  if (!str) return null;

  // 🔴 ÖNEMLİ: RFC 1123 / HTTP Date formatı
  // "Tue, 13 Oct 2026 11:38:34 GMT" veya "... +0000" veya "... +0300"
  // new Date() bu formatı doğal olarak tanır — hiç dokunma!
  if (/^[A-Za-z]{3},\s+\d{1,2}\s+[A-Za-z]{3}\s+\d{4}/.test(str)) {
    // DIA API yanlışlıkla "GMT" ekliyor ama saat aslında TR saati.
    // GMT/UTC etiketini kaldır → JavaScript yerel saat olarak yorumlar.
    const cleaned = str
      .replace(/\s+(GMT|UTC)\s*$/i, "")
      .replace(/\s*[+-]\d{4}\s*$/, "");
    const d = new Date(cleaned);
    return isNaN(d.getTime()) ? null : d;
  }

  // Sayısal string timestamp
  if (/^\d{10,13}$/.test(str)) {
    const num = Number(str);
    const ms = str.length === 10 ? num * 1000 : num;
    const d = new Date(ms);
    return isNaN(d.getTime()) ? null : d;
  }

  // MySQL DATETIME / DATE: "2026-05-20 15:48:49" veya "2026-05-20"
  let normalized = str.includes("T") ? str : str.replace(" ", "T");

  // Timezone bilgisi var mı? (Z veya +HH:MM veya +HHMM)
  const hasTz = /[Zz]$|[+-]\d{2}:?\d{2}$/.test(normalized);

  // Timezone yoksa ve ISO benzeri ise → UTC kabul et
  if (
    !hasTz &&
    /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?)?$/.test(normalized)
  ) {
    normalized += "Z";
  }

  // Dene
  let d = new Date(normalized);
  if (!isNaN(d.getTime())) return d;

  // Fallback
  d = new Date(str);
  if (!isNaN(d.getTime())) return d;

  console.warn("⚠️ Parse edilemeyen tarih formatı:", str);
  return null;
}

/** Saat: "14:38" */
function formatTime(value) {
  const d = parseServerDate(value);
  if (!d) return "";

  const hh = d.getHours().toString().padStart(2, "0");
  const mm = d.getMinutes().toString().padStart(2, "0");
  return `${hh}:${mm}`;
}

/** Gün etiketi: "Bugün", "Dün", "Pazartesi" veya "13 Eki 2026" */
function formatDayLabel(value) {
  const d = parseServerDate(value);
  if (!d) return "";

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const that = new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const diffDays = Math.round((today - that) / 86400000);

  if (diffDays === 0) return "Bugün";
  if (diffDays === 1) return "Dün";
  if (diffDays > 1 && diffDays < 7) {
    return [
      "Pazar",
      "Pazartesi",
      "Salı",
      "Çarşamba",
      "Perşembe",
      "Cuma",
      "Cumartesi",
    ][d.getDay()];
  }

  const months = [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara",
  ];
  const year =
    d.getFullYear() !== now.getFullYear() ? ` ${d.getFullYear()}` : "";
  return `${d.getDate()} ${months[d.getMonth()]}${year}`;
}

/** İki tarihin farklı güne ait olup olmadığını kontrol eder */
function isDifferentDay(a, b) {
  const d1 = parseServerDate(a);
  const d2 = parseServerDate(b);
  if (!d1 || !d2) return false;
  return (
    d1.getFullYear() !== d2.getFullYear() ||
    d1.getMonth() !== d2.getMonth() ||
    d1.getDate() !== d2.getDate()
  );
}

/* ─────────────── Ana Bileşen ─────────────── */

export default function SupportMessages({ user }) {
  const navigate = useNavigate();
  const { supportId } = useParams();
  const location = useLocation();
  const initial = location.state || {};

  const userId = user?.user_id;
  const username = user?.username;

  /* ─── Panel tipi ─── */
  const rawUserType = String(user?.user_type || "").toLowerCase();
  const isSupporter = rawUserType === "destek";
  const messageUserType = isSupporter ? "nortek" : "user";

  /* ─── sunucuKodu state ─── */
  const [sunucuKodu, setSunucuKodu] = useState(
    isSupporter
      ? initial.sunucuKodu || user?.sunucu_kodu || ""
      : user?.sunucu_kodu || "",
  );

  const [messages, setMessages] = useState([]);
  const [title] = useState(initial.title || "Destek");
  const [status] = useState(initial.status || "");
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [showScrollDown, setShowScrollDown] = useState(false);

  const prevCountRef = useRef(0);
  const firstScrollDoneRef = useRef(false);
  const pollRef = useRef(null);
  const messagesRef = useRef(null);
  const bottomRef = useRef(null);
  const fileRef = useRef(null);

  const statusLower = (status || "").toLowerCase();
  const isCompleted = statusLower.includes("tamam");
  const isCancelled =
    statusLower.includes("cancel") || statusLower.includes("iptal");
  const isReadOnly = isCompleted || isCancelled;

  /* ─────────────── Normalize ─────────────── */
  const normalized = useMemo(() => {
    const mapped = messages.map((m) => {
      const senderIdRaw = m.senderId ?? m.sender_id ?? m.senderid;
      const senderNameRaw =
        m.senderName ?? m.sender_name ?? m.owner_username ?? "Bilinmiyor";
      const msgType = m.type ?? m.msgType ?? "txt";
      const createdAt =
        m.created_at ?? m.createdAt ?? m.timestamp ?? m.date ?? "";
      return {
        id: m.id,
        senderId: senderIdRaw,
        senderName: senderNameRaw,
        receiverId: m.receiverId ?? m.receiver_id ?? null,
        message: m.message ?? "",
        createdAt,
        msgType,
      };
    });
    return mapped.slice().reverse();
  }, [messages]);

  /* ─────────────── Load messages ─────────────── */
  const loadMessages = useCallback(
    async (silent = false) => {
      if (!silent) setLoading(true);
      try {
        const data = await messagesService.getMessages(supportId);
        setMessages(Array.isArray(data) ? data : []);

        await messagesService.changeUpdateValue({
          target: isSupporter ? "nortek" : "user",
          newValue: false,
          userId,
          root: "msg",
        });
        await messagesService.updateUnread({
          unread: 0,
          supportId,
          type: isSupporter ? "nortek" : "user",
        });
      } catch (err) {
        console.error(err);
        if (!silent) setError("Mesajlar yüklenemedi");
      } finally {
        if (!silent) setLoading(false);
      }
    },
    [supportId, userId, isSupporter],
  );

  useEffect(() => {
    loadMessages();
  }, [loadMessages]);

  /* ─────────────── Sunucu kodu fallback (destekçi için) ─────────────── */
  useEffect(() => {
    if (!isSupporter) return;
    if (sunucuKodu) return;
    if (!normalized.length) return;
    if (!userId) return;

    const otherMsg = normalized.find(
      (m) => String(m.senderId) !== String(userId),
    );
    const customerId = otherMsg?.senderId || otherMsg?.receiverId;
    if (!customerId) return;

    let cancelled = false;
    (async () => {
      try {
        const u = await messagesService.getUserById(customerId);
        if (cancelled) return;
        const kodu = u?.sunucu_kodu || "";
        if (kodu) setSunucuKodu(kodu);
      } catch (err) {
        console.warn("Sunucu kodu alınamadı:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isSupporter, sunucuKodu, normalized, userId]);

  /* ─────────────── Polling ─────────────── */
  useEffect(() => {
    if (!userId) return;

    const tick = async () => {
      try {
        const changed = await messagesService.checkDataIsUpdated({
          target: isSupporter ? "nortek" : "user",
          userId,
          root: "msg",
        });
        if (changed) {
          playIfBackground("message");
          await loadMessages(true);
        }
      } catch (err) {
        console.warn("Polling error:", err?.message);
      }
    };
    pollRef.current = setInterval(tick, POLLING_INTERVAL_MS);
    return () => pollRef.current && clearInterval(pollRef.current);
  }, [userId, loadMessages, isSupporter]);

  /* ─────────────── Auto-scroll ─────────────── */
  useLayoutEffect(() => {
    if (loading) return;
    if (normalized.length === 0) return;
    const bottom = bottomRef.current;
    const el = messagesRef.current;
    if (!bottom || !el) return;

    const isFirstLoad = !firstScrollDoneRef.current;
    const hasNewMessage = normalized.length > prevCountRef.current;

    if (isFirstLoad) {
      bottom.scrollIntoView({ block: "end" });
      requestAnimationFrame(() => {
        bottom.scrollIntoView({ block: "end" });
      });
      firstScrollDoneRef.current = true;
    } else if (hasNewMessage) {
      const nearBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
      if (nearBottom) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            bottom.scrollIntoView({
              behavior: "smooth",
              block: "end",
            });
          });
        });
      }
    }

    prevCountRef.current = normalized.length;
  }, [normalized.length, loading]);

  /* ─────────────── Resim/audio geç yüklenince yapıştır ─────────────── */
  useEffect(() => {
    const el = messagesRef.current;
    if (!el) return;

    const onMediaLoad = () => {
      if (!firstScrollDoneRef.current) return;
      const nearBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
      if (nearBottom && bottomRef.current) {
        bottomRef.current.scrollIntoView({ block: "end" });
      }
    };

    el.addEventListener("load", onMediaLoad, true);
    el.addEventListener("loadedmetadata", onMediaLoad, true);
    return () => {
      el.removeEventListener("load", onMediaLoad, true);
      el.removeEventListener("loadedmetadata", onMediaLoad, true);
    };
  }, []);

  /* ─────────────── "Aşağı kaydır" göstergesi ─────────────── */
  useEffect(() => {
    const el = messagesRef.current;
    if (!el) return;

    const onScroll = () => {
      const nearBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX;
      setShowScrollDown(!nearBottom && normalized.length > 0);
    };

    el.addEventListener("scroll", onScroll);
    onScroll();
    return () => el.removeEventListener("scroll", onScroll);
  }, [normalized.length]);

  /* ─────────────── Karşı taraf ID ─────────────── */
  const receiverId = useMemo(() => {
    if (!normalized.length) return null;
    const last = normalized[normalized.length - 1];
    return String(last.senderId) === String(userId)
      ? last.receiverId
      : last.senderId;
  }, [normalized, userId]);

  /* ─────────────── Gönderim sonrası ─────────────── */
  const afterSend = async () => {
    await loadMessages(true);
    try {
      await messagesService.changeUpdateValue({
        target: isSupporter ? "user" : "nortek",
        newValue: true,
        userId: receiverId,
        root: "msg",
      });

      await messagesService.updateUnread({
        unread: 1,
        supportId,
        type: isSupporter ? "user" : "nortek",
      });
    } catch (e) {
      console.warn(e);
    }
  };

  /* ─────────────── Gönder ─────────────── */
  const handleSend = async () => {
    const trimmed = text.trim();
    if (!trimmed || sending || isCompleted) return;
    setSending(true);
    setError("");
    try {
      await messagesService.addMessage({
        supportId,
        senderId: userId,
        receiverId,
        message: trimmed,
        senderName: username,
        userType: messageUserType,
        type: "txt",
      });
      setText("");
      await afterSend();
    } catch (err) {
      console.error(err);
      setError("Mesaj gönderilemedi");
    } finally {
      setSending(false);
    }
  };

  /* ─────────────── Dosya ─────────────── */
  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file || sending || isCompleted) return;

    const ext = file.name.split(".").pop()?.toLowerCase() || "";
    setSending(true);
    setError("");

    try {
      let kodu = sunucuKodu;

      if (!kodu && isSupporter) {
        const otherMsg = normalized.find(
          (m) => String(m.senderId) !== String(userId),
        );
        const customerId = otherMsg?.senderId || otherMsg?.receiverId;

        if (customerId) {
          try {
            const u = await messagesService.getUserById(customerId);
            kodu = u?.sunucu_kodu || "";
            if (kodu) setSunucuKodu(kodu);
          } catch (err) {
            console.warn("Sunucu kodu çekilemedi:", err);
          }
        }
      }

      const res = await messagesService.uploadFile(file, kodu, ext);
      const url = res?.url;
      if (!url) throw new Error("Yükleme başarısız");

      await messagesService.addMessage({
        supportId,
        senderId: userId,
        receiverId,
        message: url,
        senderName: username,
        userType: messageUserType,
        type: ext,
      });
      await afterSend();
    } catch (err) {
      console.error("[Upload error]", err?.response?.data || err);
      setError(err?.message || "Dosya yüklenemedi");
    } finally {
      setSending(false);
    }
  };

  /* ─────────────── Aşağı kaydır ─────────────── */
  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  /* ─────────────── Render ─────────────── */
  return (
    <Box
      sx={{
        height: "100dvh",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        position: "relative",
        backgroundColor: "#ECE5DD",
      }}
    >
      {/* WhatsApp benzeri arka plan dokusu */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          opacity: 0.35,
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.6) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.5) 0%, transparent 40%)",
        }}
      />

      <Paper
        elevation={0}
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          borderRadius: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          bgcolor: "transparent",
          animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both`,
        }}
      >
        {/* ─────────── HEADER ─────────── */}
        <Box
          sx={{
            px: { xs: 1.5, sm: 2 },
            py: 1.25,
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            background: "linear-gradient(135deg, #045781 0%, #0d6a9e 100%)",
            color: "#fff",
            boxShadow: "0 2px 12px rgba(4,87,129,0.25)",
            zIndex: 2,
            animation: `${slideDown} 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
          }}
        >
          <IconButton
            onClick={() => navigate(-1)}
            size="small"
            sx={{
              color: "#fff",
              transition: "transform 0.2s ease",
              "&:hover": {
                transform: "translateX(-3px)",
                backgroundColor: "rgba(255,255,255,0.12)",
              },
            }}
          >
            <ArrowBackRounded />
          </IconButton>
          <Typography
            sx={{
              fontWeight: 700,
              flex: 1,
              minWidth: 0,
              color: "#fff",
              fontSize: 15.5,
            }}
            noWrap
          >
            {title}
          </Typography>
          {isReadOnly && (
            <Typography
              variant="caption"
              sx={{
                color: "#fff",
                fontWeight: 700,
                bgcolor: isCancelled
                  ? "rgba(185,28,28,0.55)"
                  : "rgba(255,255,255,0.20)",
                border: isCancelled
                  ? "1px solid rgba(254,202,202,0.5)"
                  : "1px solid rgba(255,255,255,0.28)",
                px: 1,
                py: 0.25,
                borderRadius: 10,
                animation: `${fadeIn} 0.4s ease-out 0.3s backwards`,
              }}
            >
              {isCancelled ? "İptal Edildi" : "Tamamlandı"}
            </Typography>
          )}
        </Box>

        {/* ─────────── MESSAGES ─────────── */}
        <Box
          ref={messagesRef}
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            overscrollBehavior: "contain",
            p: { xs: 1.5, sm: 2 },
            position: "relative",
            backgroundColor: "rgba(236,229,221,0.6)",
            "&::-webkit-scrollbar": { width: 8 },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "rgba(15,50,65,0.15)",
              borderRadius: 4,
            },
            "&::-webkit-scrollbar-thumb:hover": {
              bgcolor: "rgba(15,50,65,0.28)",
            },
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 6,
                gap: 1.5,
              }}
            >
              <CircularProgress size={32} />
              <Typography
                variant="caption"
                sx={{
                  color: textSecondary,
                  fontWeight: 600,
                  animation: `${fadeIn} 1s ease-out both`,
                }}
              >
                Mesajlar yükleniyor…
              </Typography>
            </Box>
          ) : normalized.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 8,
                gap: 1.5,
                animation: `${fadeInUp} 0.5s ease-out 0.2s backwards`,
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: `${accentColor}14`,
                  color: accentColor,
                  animation: "emptyPulse 2.4s ease-in-out infinite",
                  "@keyframes emptyPulse": {
                    "0%, 100%": { transform: "scale(1)" },
                    "50%": { transform: "scale(1.06)" },
                  },
                }}
              >
                <SendRounded sx={{ fontSize: 28 }} />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  color: textSecondary,
                  fontWeight: 600,
                  fontSize: 13.5,
                }}
              >
                Henüz mesaj yok. İlk mesajı siz gönderin.
              </Typography>
            </Box>
          ) : (
            <>
              {normalized.map((m, i) => {
                const isMine = String(m.senderId) === String(userId);
                const isNew = i >= prevCountRef.current;
                const prev = i > 0 ? normalized[i - 1] : null;
                const showDaySeparator =
                  !prev || isDifferentDay(prev.createdAt, m.createdAt);

                return (
                  <Box key={m.id}>
                    {showDaySeparator && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          my: 1.5,
                          animation: `${fadeIn} 0.4s ease-out both`,
                        }}
                      >
                        <Box
                          sx={{
                            px: 1.5,
                            py: 0.4,
                            borderRadius: 10,
                            backgroundColor: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(15,50,65,0.08)",
                            boxShadow: "0 1px 3px rgba(15,50,65,0.06)",
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#546e7a",
                            textTransform: "uppercase",
                            letterSpacing: "0.04em",
                          }}
                        >
                          {formatDayLabel(m.createdAt)}
                        </Box>
                      </Box>
                    )}

                    <MessageCard
                      msg={m.message}
                      name={m.senderName}
                      time={formatTime(m.createdAt)}
                      isMine={isMine}
                      msgType={m.msgType}
                      animate={isNew}
                      index={i}
                    />
                  </Box>
                );
              })}
              {/* Bottom anchor */}
              <div ref={bottomRef} style={{ height: 1 }} />
            </>
          )}

          {/* Aşağı kaydır butonu */}
          {showScrollDown && (
            <Box
              onClick={scrollToBottom}
              sx={{
                position: "sticky",
                bottom: 8,
                ml: "auto",
                mr: 0.5,
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "rgba(255,255,255,0.98)",
                border: "1px solid rgba(15,50,65,0.12)",
                boxShadow: "0 4px 14px rgba(15,50,65,0.18)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 5,
                animation: "floatIn 0.3s cubic-bezier(0.22, 1, 0.36, 1) both",
                "@keyframes floatIn": {
                  from: { opacity: 0, transform: "translateY(8px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
                "&:hover": {
                  backgroundColor: "#fff",
                  transform: "scale(1.06)",
                },
                "&:active": { transform: "scale(0.94)" },
              }}
            >
              <KeyboardArrowDownRounded sx={{ color: "#334155" }} />
            </Box>
          )}
        </Box>

        {error && (
          <Alert
            severity="error"
            sx={{
              mx: 1.5,
              my: 0.5,
              animation: `${slideUp} 0.3s ease-out both`,
            }}
            onClose={() => setError("")}
          >
            {error}
          </Alert>
        )}

        {/* ─────────── INPUT ─────────── */}
        <Box
          sx={{
            px: { xs: 1.5, sm: 2 },
            py: 1.25,
            display: "flex",
            gap: 1,
            alignItems: "flex-end",
            borderTop: "1px solid rgba(15,50,65,0.08)",
            backgroundColor: "#fff",
            boxShadow: "0 -2px 12px rgba(15,50,65,0.06)",
            flexShrink: 0,
            zIndex: 2,
            animation: `${slideUp} 0.45s cubic-bezier(0.22, 1, 0.36, 1) 0.15s backwards`,
          }}
        >
          <input
            ref={fileRef}
            type="file"
            hidden
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.xml"
            onChange={handleFileChange}
          />
          <IconButton
            onClick={() => fileRef.current?.click()}
            disabled={isReadOnly || sending}
            title="Dosya ekle"
            sx={{
              transition: "transform 0.2s ease, color 0.2s ease",
              "&:hover": {
                transform: "scale(1.1) rotate(-12deg)",
                color: accentColor,
              },
              "&:active": { transform: "scale(0.92) rotate(0deg)" },
            }}
          >
            <AttachFileRounded />
          </IconButton>

          <TextField
            fullWidth
            multiline
            maxRows={6}
            size="small"
            placeholder={
              isCancelled
                ? "Bu talep iptal edildi"
                : isCompleted
                  ? "Bu talep tamamlandı"
                  : "Mesaj..."
            }
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={isReadOnly}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSend();
              }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                transition:
                  "box-shadow 0.25s ease, background-color 0.25s ease",
                "&.Mui-focused": {
                  boxShadow: `0 0 0 3px ${accentColor}22`,
                },
              },
            }}
          />

          <IconButton
            onClick={handleSend}
            disabled={isReadOnly || sending || !text.trim()}
            sx={{
              bgcolor: accentColor,
              color: "#fff",
              transition:
                "transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
              "&:hover": {
                bgcolor: accentColor,
                opacity: 0.95,
                transform: "scale(1.08) rotate(-8deg)",
              },
              "&:active": { transform: "scale(0.9)" },
              "&.Mui-disabled": { bgcolor: "#ccc", color: "#fff" },
              "&:not(:disabled)": {
                animation: `${sendPulse} 1.8s ease-out infinite`,
              },
            }}
          >
            {sending ? (
              <CircularProgress size={20} sx={{ color: "#fff" }} />
            ) : (
              <SendRounded />
            )}
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
}
